// extracted by mini-css-extract-plugin
export default {"price":"styles_price__cyooI","editIcon":"styles_editIcon__tU91l"};